import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingPage = ({ translations }) => (
  <div className="fixed inset-0 bg-white bg-opacity-75 flex items-center justify-center">
    <div className="text-center">
      <Loader2 className="h-16 w-16 animate-spin text-blue-600 mx-auto mb-4" />
      <h2 className="text-xl font-semibold text-gray-900 mb-2">{translations("generating")}</h2>
      <p className="text-gray-600">{translations("generating.message")}</p>
    </div>
  </div>
);

export default LoadingPage;
